import React from 'react'

import SectionHeader from '../components/SectionContent'
import Figure from '../components/Figure'

const iosIcon = require('../../assets/img/Icon_iPhone.svg')
const ipadIcon = require('../../assets/img/Icon_iPad.svg')
const webIcon = require('../../assets/img/Icon_Web.svg')

const Devices = () => (
  <section className="bg-gray" id="devices">
    <div className="container">
      <SectionHeader
        headerColor="text-white"
        headerContent="Your grow data is always within reach"
      />
      <div className="columns device-row">
        <a href="https://itunes.apple.com/us/app/farmhand-connect-tracking/id1043065780">
          <Figure
            figClass="column"
            imgSrc={iosIcon}
            imgAlt="iPhone Vector"
            imgId="ios"
            capClass="text-white"
            capContent="iOS"
          />
        </a>
        <a href="https://itunes.apple.com/us/app/farmhand-connect-tracking/id1043065780">
          <Figure
            figClass="column"
            imgSrc={ipadIcon}
            imgAlt="iPad Vector"
            imgId="ipad"
            capClass="text-white"
            capContent="iPad"
          />
        </a>
        <a href="https://www.myfarmhand.com/dashboard/">
          <Figure
            figClass="column"
            imgSrc={webIcon}
            imgAlt="Webpage Vector"
            imgId="web"
            capClass="text-white"
            capContent="Web"
          />
        </a>
      </div>
    </div>
  </section>
)

export default Devices



// WEBPACK FOOTER //
// ./containers/Devices.js